import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createCheckbox = (
  parentId: string,
  defaultText: string,
  masterBlockId?: MasterBlockIdType,
): CheckboxInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.Checkbox, parentId, masterBlockId),
    content: `<p>${defaultText}</p>`,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    fontSize: 16,
    errorText: 'settings_options.checkbox_message',
    optional: false,
    textAlign: 'left',
  }
}
